import { HomologacaoAtividade } from './homologacao-atividade.model';
import { GerenciamentoComissao } from './gerenciamento-comissao.model';

export class HomologacaoComissao extends HomologacaoAtividade {

    public id_comissao: number;

    comissao: GerenciamentoComissao;
}


// WEBPACK FOOTER //
// ./src/app/entity/homologacao-comissao.model.ts